import { Button } from "../f7";

/**
 * The foot of a cursor-paged list: how many rows are on screen, whether the
 * server holds more, and the button that fetches them.
 *
 * The count says which of the two it is. A first page that reads as the
 * whole list tells an operator something never happened.
 */
export function LoadMore({
  shown,
  noun,
  hasMore,
  loading,
  error,
  onMore,
}: {
  shown: number;
  /** Plural, e.g. "changes". */
  noun: string;
  hasMore: boolean;
  loading: boolean;
  error: string | null;
  onMore: () => void;
}) {
  return (
    <div className="mt-4 flex flex-wrap items-center gap-3">
      <p className="text-xs text-slate-500 dark:text-slate-400">
        {hasMore
          ? `Showing ${shown} ${noun} — more remain on the server.`
          : `Showing all ${shown} ${noun}.`}
      </p>
      {hasMore && (
        <Button outline disabled={loading} onClick={onMore}>
          {loading ? "Loading…" : "Load more"}
        </Button>
      )}
      {error && <p className="text-xs text-amber-700 dark:text-amber-400">{error}</p>}
    </div>
  );
}
